import React, { forwardRef, useState } from 'react';

// MAIN COMPONENT
export const handleAsync = Component => {
  return forwardRef(({
    ...props
  }, ref) => {

    // PROPS
    const {
      options: rawOptions,
      onLoadOptions
    } = props;

    // STATE
    const [options, setOptions] = useState(rawOptions);

    const handleLoadOptions = async v => {
      const asyncOptions = await onLoadOptions(v);
      if (asyncOptions?.length) {
        setOptions(asyncOptions);
      }
      return asyncOptions;
    };

    // RENDER
    return <Component
      {...props}
      options={options}
      loadOptions={!!onLoadOptions ? handleLoadOptions : undefined}
      ref={ref}
    />
  })
}
